import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'

import DeepCopyStep from './Steps/DeepCopyStep'
import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import StatusStep from './Steps/StatusStep'
import LineItemDuplicationProgress from './Steps/LineItemDuplicationProgressStep'
import CampaignStep from './Steps/CampaignStep'
import StartTimeStep from './Steps/StartTimeStep'
import StopTimeStep from './Steps/StopTimeStep'
import StepForm from '../../../../features/components/Forms/StepForm'

import { usePurifiedFormik } from '../../../../hooks/formHooks/usePurifiedFormik'
import useManageDrawer from '../../../../hooks/formHooks/useManageDrawer'

import { clearAsyncSession } from '../../../../modules/actions/app'
import {
  duplicateLineItemErrorSelector,
  duplicateLineItemIsLoadingSelector
} from '../../../../modules/selectors/lineItems'
import { clearDuplicateLineItem } from '../../../../modules/actions/lineItems'

import { LINE_ITEM_FACEBOOK_DUPLICATE } from '../../../../constants/forms'
import { initialValues, validationSchema } from './fields'

function LineItemFacebookDuplicate() {
  const dispatch = useDispatch()

  const clearDuplicateCampaignHandler = useCallback(() => {
    dispatch(clearDuplicateLineItem())
    dispatch(clearAsyncSession())
  }, [dispatch])

  const { handleFormClose, selectedEditItemId } = useManageDrawer({
    onAfterFormClose: clearDuplicateCampaignHandler,
    formName: LINE_ITEM_FACEBOOK_DUPLICATE
  })

  const onSuccessSubmit = useCallback(() => {
    handleFormClose()
  }, [handleFormClose])

  const formik = useFormik({
    initialValues,
    validationSchema
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const steps = useMemo(
    () => [
      {
        component: <CampaignStep />,
        show: true
      },
      {
        component: <DeepCopyStep />,
        show: true
      },
      {
        component: <StartTimeStep />,
        show: true
      },
      {
        component: <StopTimeStep />,
        show: true
      },
      {
        component: <StatusStep selectedEditItemId={selectedEditItemId} />,
        show: true
      },
      {
        component: <LineItemDuplicationProgress onSuccessSubmit={onSuccessSubmit} />,
        show: true
      }
    ],
    [selectedEditItemId, onSuccessSubmit]
  )

  return (
    <FormDrawerWrapper formName={LINE_ITEM_FACEBOOK_DUPLICATE} showOpenButton={false}>
      <StepForm
        formName={LINE_ITEM_FACEBOOK_DUPLICATE}
        steps={steps}
        formik={purifiedFormik}
        submitOnLastStep={false}
        errorSelector={duplicateLineItemErrorSelector}
        isLoadingSelector={duplicateLineItemIsLoadingSelector}
      />
    </FormDrawerWrapper>
  )
}

export default LineItemFacebookDuplicate
